export default __webpack_public_path__ + "static/button-decoration-dont-light-2b5a8ceca9b41c49713eb8d150757f2e04570471f21464dda8a5c675cd84693f.png";